import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { Stack } from '@mui/system';
import { useQueryState } from 'nuqs';
import React from 'react';
import Iconify from 'src/components/iconify';
import { useTranslate } from 'src/locales';

export const ExclusiveEventDialog = () => {
  const [isExclusiveOpen, setIsExclusiveEvent] = useQueryState('exclusive');
  const { t } = useTranslate('connect');

  const onClose = () => {
    setIsExclusiveEvent(null);
  };

  const steps = [
    { icon: '📝', text: t('exclusiveEvent.step1') || 'Submit your request' },
    { icon: '✅', text: t('exclusiveEvent.step2') || 'Get approved by our team' },
    { icon: '🎟️', text: t('exclusiveEvent.step3') || 'Show your valid ticket' },
  ];

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={isExclusiveOpen === 'open'}
      onClose={onClose}
      PaperProps={{
        sx: {
          mx: 3,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 'none',
        },
      }}
    >
      <DialogTitle>
        <Iconify icon="" sx={{ color: 'primary.main', fontSize: 30 }} />
        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
          ✨ {t('exclusiveEvent.title') || 'Request Your VIP Access'} ✨
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          gap: 1,
        }}
      >
        <Typography variant="subtitle1">
          <Iconify icon="" sx={{ color: 'primary.main' }} />
          {t('exclusiveEvent.subtitle') || 'Hey there, exclusive seeker! 🌟'}
        </Typography>

        <Stack gap={1}>
          {steps.map((step, index) => (
            <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <Typography color="primary" variant="caption" sx={{ fontWeight: 'bold' }}>
                {index + 1} .
              </Typography>
              <Typography variant="caption">
                {step.text} {step.icon}
              </Typography>
            </Box>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, justifyContent: 'center' }}>
        <Button variant="outlined" onClick={onClose} sx={{ borderRadius: 'full', px: 4 }}>
          {t('exclusiveEvent.later') || 'Later'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
